<div class="o3-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close ChatGPT o3 Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/openai.svg" alt="ChatGPT o3 Logo" class="mini-logo" />
    <h2>ChatGPT&nbsp;o3</h2>
    <div class="sub">Deep reasoning — built for careful analysis, technical work, and structured thinking</div>
  </div>

  <div class="body">
    <p>
      <strong>ChatGPT&nbsp;o3</strong> is optimized for deeper, more deliberate reasoning. It’s designed to do well when tasks
      require multi-step logic, careful constraint handling, and clear explanations—especially in domains like
      <strong>engineering</strong>, <strong>data work</strong>, <strong>planning</strong>, and <strong>complex decision support</strong>.
      If you want answers that are not just fast, but <strong>thoughtful</strong> and <strong>well-structured</strong>, o3 is a strong fit.
    </p>

    <ul>
      <li>🧠 <strong>Multi-step reasoning:</strong> better at chaining logic across multiple steps, keeping assumptions consistent, and avoiding “hand-wavy” jumps.</li>
      <li>🧩 <strong>Constraint discipline:</strong> follows requirements, formats, and rules more reliably (useful for specs, schemas, and strict outputs).</li>
      <li>👨‍💻 <strong>Technical depth:</strong> strong for debugging, refactoring, architecture discussions, and explaining tradeoffs in code and systems.</li>
      <li>📚 <strong>Long-form clarity:</strong> great for teaching-style breakdowns, step-by-step walkthroughs, and readable summaries.</li>
      <li>🧭 <strong>Decision support:</strong> helpful for comparing options, mapping pros/cons, and producing structured recommendations.</li>
      <li>🔎 <strong>Better analysis under ambiguity:</strong> more likely to ask the right internal questions, state assumptions, and propose next checks.</li>
    </ul>

    <div class="optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto:</strong> adapts effort to the task (quick for simple, deeper for complex).</li>
        <li><strong>Instant:</strong> fastest responses with lighter reasoning.</li>
        <li><strong>Thinking:</strong> balanced depth for most work—good default.</li>
        <li><strong>Pro:</strong> maximum rigor for high-stakes or complex problem solving.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Best when to use ChatGPT&nbsp;o3</h3>
      <ul>
        <li>When the problem needs careful, stepwise reasoning (logic, planning, analysis)</li>
        <li>For production-grade coding help: debugging, refactors, and technical validation</li>
        <li>When you want structured outputs: checklists, tables, schemas, or specs</li>
        <li>For long-context work: large documents, policies, or multi-part prompts</li>
        <li>When accuracy and consistency matter more than raw speed</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>How to get the best results</h3>
      <ul>
        <li><strong>Give context + goal:</strong> what you’re trying to achieve, who it’s for, and what “good” looks like.</li>
        <li><strong>State constraints:</strong> required format, tone, length, and any “must / must not” rules.</li>
        <li><strong>Ask for validation:</strong> request edge cases, assumptions, and a quick sanity check for important outputs.</li>
        <li><strong>Provide sources:</strong> paste specs/logs/error messages so the model can ground its reasoning.</li>
      </ul>
    </div>
  </div>
</div>
